module.exports = __webpack_public_path__ + "img/3072df6.png";